module.exports = __webpack_public_path__ + "media/secret.5a103fe9.mp3";